<div class="card flex justify-content-start mb-2">
  <div class="flex flex-column gap-2">
    <div *ngFor="let permission of permissions" class="field-checkbox">
      <p-checkbox [(ngModel)]="selectedPermissions" [inputId]="'perm-' + permission.id" name="group" [value]="permission" />
      <label [for]="'perm-' + permission.id">{{ permission.description }}</label>
    </div>
  </div>
</div>
<div class="flex justify-content-end">
  <p-button severity="secondary" (onClick)="permissionsChange.emit(selectedPermissions)" [label]="'Modifier'" ></p-button>
</div>
